import React from "react";
import SectionWrapper from "components/elements/SectionWrapper";
import SmartLink from "components/SmartLink";
import styles from './BreadcrumbsSection.module.scss';

/**
 * Breadcrumbs navigation component that displays the current page location
 * 
 * @param {Object} props - Component properties
 * @param {string} props.title - Current page title
 * @param {string} props.back_link - Optional link to parent page
 * @param {string} props.back_link_text - Optional text for back link
 * @param {boolean} props.fluid - Whether to use container-fluid
 * @param {boolean} props.is_absolute - Whether breadcrumbs should be positioned absolutely
 */
const BreadcrumbsSection = (props) => {
	const { title, back_link, back_link_text, fluid, is_absolute = true } = props;
	
	const absoluteStyles = is_absolute ? "position-absolute" : "position-relative";
	
	return (
		<SectionWrapper
			{...props}
			className={`${styles.BreadcrumbsSection} ${props.className || ""}`}
			title={null}>
			<nav aria-label="breadcrumb">
				<div className={`${fluid ? "container-fluid" : "container"} position-relative`}>
					<ol className={`${absoluteStyles} breadcrumb fw-medium`}>
						{/* Always first entry: Home page */}
						<li className="breadcrumb-item">
							<SmartLink 
								to="/" 
								className="text-decoration-none"
								aria-label="Navigate to home page">
								Startseite
							</SmartLink>
						</li>
						{/* If back_link is available, show as second entry */}
						{back_link && (
							<li className="breadcrumb-item">
								<SmartLink 
									to={back_link} 
									className="text-decoration-none"
									aria-label={`Navigate to ${back_link_text || "overview"}`}>
									{back_link_text || "Zurück zur Übersicht"}
								</SmartLink>
							</li>
						)}
						{/* Active element */}
						<li className="breadcrumb-item active" aria-current="page">
							{title}
						</li>
					</ol>
				</div>
			</nav>
		</SectionWrapper>
	);
};

export default BreadcrumbsSection;